import { axios } from '../../services/axios';

export default async function updateSRTService(params) {
    const result = await axios.put('/Service/SRT', params);
    return result;
}
